// extracted by mini-css-extract-plugin
module.exports = {"tagContainer":"TagDetailsModal_tagContainer__Ky4T7"};